import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

function Home() {
  const { isAdmin, isClient } = useAuth();

  return (
    <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-lg-7 mb-4 mb-lg-0">
          <h1 className="display-4 fw-bold mb-3">Автоматизация подписи документов онлайн</h1>
          <p className="lead mb-4">
            Экономьте время и ресурсы — подписывайте, отправляйте и управляйте документами в пару кликов. Надёжно, быстро и с юридической силой.
          </p>
          <ul className="list-unstyled mb-4">
            <li className="mb-2"><i className="fas fa-check-circle text-success me-2"></i>Безопасно и законно</li>
            <li className="mb-2"><i className="fas fa-check-circle text-success me-2"></i>Для бизнеса, юристов, фрилансеров и госучреждений</li>
            <li className="mb-2"><i className="fas fa-check-circle text-success me-2"></i>Интеграция с вашими системами</li>
          </ul>
          <div className="d-flex flex-wrap gap-3">
            {/* Admin-specific buttons */}
            {isAdmin() && (
              <>
                <Link to="/template-docs" className="btn btn-primary btn-lg">
                  <i className="fas fa-file-alt me-2"></i>Шаблоны документов
                </Link>
                <Link to="/upload-sign-doc" className="btn btn-outline-success btn-lg">
                  <i className="fas fa-upload me-2"></i>Загрузить документ
                </Link>
              </>
            )}
            
            {/* Client-specific buttons */}
            {isClient() && (
              <Link to="/launches" className="btn btn-primary btn-lg">
                <i className="fas fa-rocket me-2"></i>Запуски
              </Link>
            )}
            
            {/* Common buttons for both roles */}
            <Link to="/about" className="btn btn-outline-secondary btn-lg">
              <i className="fas fa-info-circle me-2"></i>О сервисе
            </Link>
          </div>
        </div>
        <div className="col-lg-5 text-center">
          <img src="/main.png" alt="Электронная подпись" className="img-fluid rounded shadow" style={{maxHeight: 320}} />
        </div>
      </div>
    </div> 
  );
} 

export default Home;